<!-- cms outlet block -->
<icms-outlet-block class="w-12"
                  variant="500-page"
                  name="500page">
</icms-outlet-block>